<div class="text-center">
  <h1 class="text-primary font-3xl mb-2" [translate]="'paymentIntent.paymentRequest.title'">
    Payment request
  </h1>

  <div class="font-xl">
    {{'paymentIntent.paymentRequest.fromSource' | translate: {
    requestFrom: requestFrom,
    number: paymentIntent.order.multiOrder.number
  } }}
  </div>

  <div class="mt-5 to-pay d-inline-block">
    <span class="font-xl" [translate]="'paymentIntent.paymentRequest.toBePaid'">To be paid</span><strong
    class="font-3xl ps-2">{{paymentIntent.amount | currencyFormat: paymentIntent.order.bakery.country.currencySymbol}}</strong>
  </div>

  <ui-message class="payment-process-error mt-5"
              *ngIf="error === 'true'"
              [type]="'error'">
      <span [translate]="'notifications.error.paymentCreation.paymentSystemErrorMessage'">
        We didn't manage to process you payment, please try again
      </span>
  </ui-message>

  <div [ngBusy]="{busy: pPayment, message: ('common.pleaseWait' | translate)}" class="mt-5">
    <div class="choose-payment-section mx-auto">
      <h4 class="mb-3" [translate]="'paymentIntent.paymentRequest.selectPaymentMethod'">Select payment method</h4>
      <choose-payment-type
        class="d-block mb-2"
        [btnColor]="'secondary'"
        [paymentMethods]="paymentMethods"
        [(paymentType)]="currentPaymentType"
        (paymentTypeChange)="pay($event, null)"
      ></choose-payment-type>

      <div class="font-xl"
           [innerHTML]="'paymentIntent.paymentRequest.payWithinNextHours' | translate">
      </div>

      <ng-container *ngIf="currentPaymentType === PAYMENT_PLATFORM_TYPES.klarna">
        <div [ngBusy]="{busy: snippetLoading, message: ('common.pleaseWait' | translate)}"
             class="klarna-wrap mt-5">
          <div class="klarna-logo"></div>
          <div class="data-snippet" data-snippet>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

